/**
 * ZEN ERP — Teklif Revizyon Geçmişi Modal
 * QuoteBuilderPage.jsx'ten çıkarıldı.
 */
import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import api from "../api";

export function QuoteRevisionHistoryModal({ quoteNo, onClose, onPreview }) {
  const [revisions, setRevisions] = useState(null);
  useEffect(() => {
    api.get(`/quotes/history/${quoteNo}`)
      .then(({ data }) => setRevisions(data || []))
      .catch(() => setRevisions([]));
  }, [quoteNo]);

  const dt = (v) => new Date(v).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const fmtAmt = (n, c) => new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + " " + (c || "TL");

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="zen-panel w-full max-w-lg p-5 space-y-4" data-testid="revision-history-modal">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-bold text-sm">Teklif #{quoteNo} — Revizyon Geçmişi</h4>
            <p className="text-[11px] text-slate-400 mt-0.5">Arşivlenen eski versiyonlar ve aktif revizyon</p>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-slate-100 dark:hover:bg-[#22304A] rounded-lg"><X className="w-4 h-4" /></button>
        </div>
        {revisions === null ? (
          <div className="text-center py-8 text-slate-400 text-sm">Yükleniyor…</div>
        ) : revisions.length === 0 ? (
          <div className="text-center py-8 text-slate-400 text-sm">Bu teklif için revizyon geçmişi bulunamadı.</div>
        ) : (
          <div className="space-y-2">
            {[...revisions].reverse().map((r) => (
              <div key={r.id} className={`flex items-center gap-3 p-3 rounded-xl border transition-colors ${r.isArchived ? "border-slate-200 dark:border-[#22304A] opacity-70" : "border-amber-400/40 bg-amber-500/5"}`} data-testid={`revision-row-${r.revisionNo || 1}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-bold text-sm">#{r.quoteNo}</span>
                    {(r.revisionNo || 1) > 1
                      ? <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-amber-500/15 text-amber-600">Rev {r.revisionNo}</span>
                      : <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-slate-500/15 text-slate-500">İlk Versiyon</span>}
                    {r.isArchived
                      ? <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-500">Arşiv</span>
                      : <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-500/15 text-emerald-600">Aktif</span>}
                  </div>
                  <div className="text-[11px] text-slate-400 mt-0.5">{dt(r.createdAt)} · {r.preparedBy || "—"} · {fmtAmt(r.total, r.currency)}</div>
                  {r.projectName && <div className="text-[11px] text-slate-500 truncate">{r.projectName}</div>}
                </div>
                <button onClick={() => onPreview(r)} className="zen-btn-ghost !text-[10px] !py-1 !px-2 shrink-0" data-testid={`revision-view-${r.revisionNo || 1}`}>
                  Görüntüle
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
